<template>
<div>
  <vue-headful
        :title="company.name + ' - Fernando Mata'"
      />
      <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
      <article class="post">
          <section class="companyHeader">
            <a :href="company.companyInformation.website" target=":blank">
              <img class="companyImage" :src="'/companies/'+ company.urlPath + '/' + company.logo">
            </a>
            <div class="headLine">
                <h1>{{company.name}}</h1>
            </div>
        </section>
        <hr>
        <section class="columnInformation" id="basicInformation" :class="mq == 'tiny' ? 'column' : '' ">
          <div class="information">
          <h3>{{$t("companyDetail.position")}}: {{company.role}}</h3>
          <h4>{{$t("companyDetail.location")}}: {{company.location}}</h4>
          </div>
          <div class="information" :class="mq == 'tiny' ? 'column' : '' " id="dates">
          <p>{{$t("companyDetail.joinedAt")}}: {{$d(new Date(company.joinedAt), 'condensed')}}</p>
          <p v-if="company.leftAt">{{$t("companyDetail.leftAt")}}: {{$d(new Date(company.leftAt), 'condensed')}}</p>
          </div>
          </section>
          <section id="myIntro">
            <p v-html="company.description"></p>
          </section>
          <section id="projects" v-if="company.hasProjectsDetails">
            <div class="project" v-for="project in company.projects" :key="project.name">
              <h1>{{project.name}}</h1>
              <img @click="openGallery(project)" v-if="project.images" :src="'/companies/' + project.images[0]" />
              <div id="projectInformation" class="columnInformation" :class="mq == 'tiny' ? 'column' : '' ">
                <div id="osInformation">
                  <p>{{$t("companyDetail.platform")}}: {{project.platform}}</p>
                  <p>{{$t("companyDetail.os")}}: {{project.os}}</p>
                </div>
                <div>
                  <p>{{$t("companyDetail.users")}}: {{project.users}}</p>
                </div>
              </div>
              <div id="moreInformation">
                <p v-html="project.more"></p>
              </div>
            </div>
          </section>
          <section id="aboutCompany">
            <h2>{{$t("companyDetail.aboutCompany")}}</h2>
            <p v-html="company.companyInformation.description"></p>
          </section>
      </article>
</div>
</template>

<script>
import { Trans } from '../localization/Translation.js'
import Experiences from '../data/Experience.json'
import VueGallerySlideshow from 'vue-gallery-slideshow'

export default {
  data() {
    return {
      images: [],
      index: null
    }
  },
  computed: {
    mq() {
      return this.$mq
    },
    company() {
      return Experiences[Trans.currentLanguage].find((a) => a.urlPath == this.$route.params.company)
    }
  },
  methods: {
    openGallery(project) {
      this.images = project.images.map(a => "/companies/" + a)
      this.index = 0
    },
    clear() {
      this.images = []
      this.index = null
    }
  },
  name: "CompanyDetail",
  components: {
    VueGallerySlideshow
  }
}
</script>

<style scoped>
  br {
    line-height: 200%;
  }
  .companyHeader {
        display: flex;
        align-items: center;
        justify-content: left;
        flex-wrap: wrap;
    }
    .companyImage {
        height: 2rem;
        margin-right: 1rem;
    }
    .companyHeader .headLine {
        display: inline-block;
    }
    .headLine {
        margin-bottom: 0px;
    }
    .headLine h1 {
        display: block;
        margin-bottom: -6px;
    }
    .headLine h4 {
        color: #969696;
        margin-bottom: 0;
    }
    hr {
        margin-top: 16px;
        margin-bottom: 32px;
    }
    .companyHeader a {
      text-decoration: none;
      border: none;
      display: flex;
   }
   .columnInformation {
     display: flex;
     justify-content: space-between;
     align-items: left;
     flex-direction: row;
     flex-wrap: wrap;
     padding-bottom: 1rem;
   }
   .columnInformation.column {
     flex-direction: column;
     display: flex;
     justify-content: space-between;
     align-items: flex-start;
     flex-wrap: wrap;
   }
   .columnInformation h1,h2,h3,h4,p {
     margin-bottom: auto;
   }
   #dates {
     display: flex;
     justify-content: space-between;
     align-items: flex-end;
     flex-direction: column;
     flex-wrap: wrap;
     padding-bottom: 1rem;
   }
   #dates.column {
     justify-content: space-between;
     align-items: flex-start;
     margin-left: 0;
   }
   .columnInformation p {
     font-size: 0.7rem;
     padding-bottom: 0;
     margin-bottom: auto;
   }
   #projects {
     padding-bottom: 1rem;
   }
   .project {
     display: flex;
     justify-content: flex-start;
     align-items: flex-start;
     flex-direction: column;
     flex-wrap: wrap;
     padding-bottom: 1rem;
   }
   #moreInformation >>> p {
     margin-bottom: 0.4rem;
   }
   .project img {
     align-content: center;
     max-width: 50%;
     display: block;
     align-self: center;
     cursor: pointer;
   }
   #projectInformation {
     align-self: stretch;
   }
   #aboutCompany {
     margin-bottom: 2.5rem;
   }
   .vgs {
    z-index: 10001;
   }
   .vgs >>> button {
    border: none;
    padding: 0;
    line-height: 0;
    letter-spacing: 0;
    box-shadow: none;
    color: #d9d9d9 !important;
   }
</style>


